function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import { ElementModel } from './ElementModel';
import { EditorConfig } from '../../edit/EditorConfig';
export class RectangleModel extends ElementModel {
  get drawPoints() {
    if (this.localPoints.length >= 4) {
      return this.localPoints;
    }
    return this.points;
  }
  constructor(root, scope, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", true);
    _defineProperty(this, "shouldUseLocalPoints", true);
    _defineProperty(this, "localPointsPick", 4);
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', 'rectangle');
    }
    if (this.root.doc && !this.root.has('points')) {
      const initPoints = new Y.Array();
      initPoints.push([0, 0, 0, 0]);
      this.root.set('points', initPoints);
    }
    if (this.root.doc && !this.root.has('radius')) {
      this.root.set('radius', 0);
    }
  }
  subDispose() {}
  liveCursorPoint() {
    const points = this.drawPoints;
    if (points.length < 4) {
      return null;
    }
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    return new this.scope.Point(points[2], points[3]).transform(matrix);
  }
  createSegments() {
    const [a, b, c, d] = this.drawPoints;
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    const maxRadius = this.maxRadiusLength();
    const radius = this.root.get('radius') * maxRadius;
    const L7 = Math.sin(Math.PI / 4) * radius;
    const L9 = radius - L7;

    /**
         *   c1    p2        p3    c2
         *      a1              a2
         *   p1                    p4
         *   p8                    p5
         *     a3               a4
         *   c4   p7        p6     c3
         */
    let c1 = new this.scope.Point(a, b).transform(matrix);
    let c2 = new this.scope.Point(c, b).transform(matrix);
    let c3 = new this.scope.Point(c, d).transform(matrix);
    let c4 = new this.scope.Point(a, d).transform(matrix);
    const yFlag = matrix.scaling.y > 0 ? 1 : -1;
    const xFlag = matrix.scaling.x > 0 ? 1 : -1;
    const c1_c3 = new this.scope.Path.Line(c1, c3);
    const center = c1_c3.getPointAt(c1_c3.length / 2);
    const m1 = new this.scope.Matrix();
    m1.rotate(-matrix.rotation, center);
    c1 = c1.transform(m1);
    c2 = c2.transform(m1);
    c3 = c3.transform(m1);
    c4 = c4.transform(m1);
    const m2 = new this.scope.Matrix();
    m2.rotate(matrix.rotation, center);
    const p1 = c1.add([0, yFlag * radius]).transform(m2);
    const a1 = c1.add([xFlag * L9, yFlag * L9]).transform(m2);
    const p2 = c1.add([xFlag * radius, 0]).transform(m2);
    const p3 = c2.add([xFlag * -radius, 0]).transform(m2);
    const a2 = c2.add([xFlag * -L9, yFlag * L9]).transform(m2);
    const p4 = c2.add([0, yFlag * radius]).transform(m2);
    const p5 = c3.add([0, yFlag * -radius]).transform(m2);
    const a3 = c3.add([xFlag * -L9, yFlag * -L9]).transform(m2);
    const p6 = c3.add([xFlag * -radius, 0]).transform(m2);
    const p7 = c4.add([xFlag * radius, 0]).transform(m2);
    const a4 = c4.add([xFlag * L9, yFlag * -L9]).transform(m2);
    const p8 = c4.add([0, yFlag * -radius]).transform(m2);
    const path = new this.scope.Path();
    path.moveTo(p1);
    path.arcTo(a1, p2);
    path.lineTo(p3);
    path.arcTo(a2, p4);
    path.lineTo(p5);
    path.arcTo(a3, p6);
    path.lineTo(p7);
    path.arcTo(a4, p8);
    return path.segments;
  }
  createPaperItem() {
    this.item = new this.scope.Path();
    this.item.addSegments(this.createSegments());
    this.item.closePath();
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.dashArray = this.dashArray;
    this.item.strokeWidth = this.strokeWidth;
    if (this.fillColor && this.fillColor.length > 0) {
      this.item.fillColor = new this.scope.Color(this.fillColor);
    }
  }
  onVectorUpdate() {
    if (this.item) {
      this.item.removeSegments();
      this.item.addSegments(this.createSegments());
      this.item.closePath();
    }
  }
  maxRadiusLength() {
    const pointsMatrix = new this.scope.Matrix(this.pointsMatrix);
    const points = this.drawPoints;
    const topLeft = new this.scope.Point(points[0], points[1]).transform(pointsMatrix);
    const topRight = new this.scope.Point(points[2], points[1]).transform(pointsMatrix);
    const bottomLeft = new this.scope.Point(points[0], points[3]).transform(pointsMatrix);
    const width = topLeft.getDistance(topRight);
    const height = topLeft.getDistance(bottomLeft);
    return Math.min(width, height) / 2;
  }
  editorConfig() {
    const config = new EditorConfig();
    config.resizeModel = () => {
      const matrix = new this.scope.Matrix(this.pointsMatrix);
      if (!(matrix.rotation % 90 === 0)) {
        return 'four-corner';
      }
      return 'eight';
    };
    config.uniformScale = () => {
      const matrix = new this.scope.Matrix(this.pointsMatrix);
      return !(matrix.rotation % 90 === 0);
    };
    config.controlPoints.push({
      name: 'rect-radius',
      getPosition: () => {
        const matrix = new this.scope.Matrix(this.pointsMatrix);
        const points = this.drawPoints;
        const radius = this.root.get('radius') * this.maxRadiusLength();
        let c1 = new this.scope.Point(points[0], points[1]).transform(matrix);
        const c3 = new this.scope.Point(points[2], points[3]).transform(matrix);
        const c1_c3 = new this.scope.Path.Line(c1, c3);
        const center = c1_c3.getPointAt(c1_c3.length / 2);
        const m1 = new this.scope.Matrix();
        m1.rotate(-matrix.rotation, center);
        c1 = c1.transform(m1);
        const xFlag = matrix.scaling.x > 0 ? 1 : -1;
        const m2 = new this.scope.Matrix();
        m2.rotate(matrix.rotation, center);
        c1 = c1.add([xFlag * radius, 0]).transform(m2);
        return this.scope.project.view.projectToView(c1);
      },
      onPositionChange: point => {
        if (!this.item) {
          return;
        }
        const points = this.drawPoints;
        const pointsMatrix = new this.scope.Matrix(this.pointsMatrix);
        const maxRadius = Math.min(points[2] - points[0], points[3] - points[1]) / 2;
        const trPoint = point.transform(pointsMatrix.inverted());
        let nextRadius = (trPoint.x - this.points[0]) / maxRadius;
        nextRadius = Math.max(nextRadius, 0);
        nextRadius = Math.min(nextRadius, 1);
        this.root.set('radius', nextRadius);
      }
    });
    return config;
  }
  vectorKeys() {
    return ['radius'];
  }
  styleKeys() {
    return {
      include: [],
      exclude: []
    };
  }
  onStyleKeyUpdate(_key) {}
}